export enum HmiType {
  baas = 'hmi/baas',
  daas = 'hmi/daas',
  hatDirect = 'hmi/hatDirect',
}
